<div class="relative">
    <app-login-dialog></app-login-dialog>
    <app-header class="fixed top-0 left-0 w-full z-50"></app-header>
    <app-cart-overview></app-cart-overview>
    <router-outlet class="relative z-0"></router-outlet>
</div>